'use client';

import { useAtom } from 'jotai';
import React, { useState } from 'react';
import Form from '../../components/Form/Form';
import { FormComponentData } from '../../components/Form/interfaces';
import isEducationModalOpen from '../../store/educationForm';
import styles from './EducationFormModal.module.scss';
import { GAEmit, GAEvents } from '../../gtagHelper';

const EducationFormModal = () => {
  const [isModalOpen, setIsModalOpen] = useAtom(isEducationModalOpen);

  const [nameValue, setNameValue] = useState<string>('');
  const [emailValue, setEmailValue] = useState<string>('');
  const [phoneValue, setPhoneValue] = useState<string>('');
  const [messageValue, setMessageValue] = useState<string>('');

  const clearForm = () => {
    setNameValue('');
    setEmailValue('');
    setPhoneValue('');
    setMessageValue('');
  };

  const formData: FormComponentData = {
    title: 'BECOME A **STUDENT**',
    description: 'Start your learning journey to become a developer with SapientPro. We&apos;re waiting for you!',
    fields: [
      {
        id: 'educationNameField',
        name: 'educationName',
        type: 'input',
        label: 'Enter your name',
        value: nameValue,
        setValue: setNameValue,
        errors: {
          required: 'Please enter your name',
        },
      },
      {
        id: 'educationEmailField',
        name: 'educationEmail',
        type: 'input',
        inputType: 'email',
        label: 'Enter your email',
        value: emailValue,
        setValue: setEmailValue,
        errors: {
          required: 'Please provide your email address',
          custom: [{
            condition: emailValue !== '' && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue),
            value: 'Please enter a valid email',
          }],
        },
      },
      {
        id: 'educationPhoneField',
        name: 'educationPhone',
        type: 'input',
        inputType: 'tel',
        label: 'Enter your phone',
        value: phoneValue,
        setValue: setPhoneValue,
        errors: {
          required: 'Please enter your phone',
          custom: [{
            condition: phoneValue !== '' && !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(phoneValue),
            value: 'Please enter a valid phone number',
          }],
        },
      },
      {
        id: 'educationAboutField',
        name: 'educationAbout',
        type: 'textarea',
        label: 'Tell us about yourself',
        value: messageValue,
        setValue: setMessageValue,
        errors: {
          required: 'Please tell us about yourself',
        },
      },
    ],
    submitData: {
      endpoint: 'contact-form-lead/academy',
      value: {
        name: nameValue,
        email: emailValue,
        phone: phoneValue,
        aboutYourself: messageValue,
      },
      successCallback: () => GAEmit(GAEvents.learningFormSubmission),
    },
    openedModal: isEducationModalOpen,
  };

  // disable eslint rule to prevent returning not JSX component
  return ( // eslint-disable-next-line
    <>
      {isModalOpen && (
        <div className={styles.contactModal}>
          <button
            type='button'
            className={styles.closeButton}
            onClick={() => setIsModalOpen(false)}
          >
            <svg>
              <use
                xlinkHref='/media/menuClose.svg#menuCloseSVG'
                href='/media/menuClose.svg#menuCloseSVG'
              />
            </svg>
          </button>
          <Form
            data={formData}
            onSuccessSubmit={clearForm}
          />
        </div>
      )}
    </>
  );
};

export default EducationFormModal;
